import React, { FC, useEffect, useState }    from "react";
import { useDispatch, useSelector }          from "react-redux";
import { Button, Icon, Modal, Radio, Table } from "semantic-ui-react";
import GetRecordTemplates                    from "../../../../application/usecase/record/template/GetRecordTemplates";
import Date                                  from "../../../../domain/fundamentals/date/Date";
import CustomerRecord                        from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordId                      from "../../../../domain/record/customer/CustomerRecordId";
import CustomerRecordRepository              from "../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordTemplate                from "../../../../domain/record/customer/CustomerRecordTemplate";
import CustomerRecordWidget                  from "../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetId                from "../../../../domain/record/customer/widget/CustomerRecordWidgetId";
import CustomerRecordWidgets                 from "../../../../domain/record/customer/widget/CustomerRecordWidgets";
import CustomerRecordWidgetItem
                                             from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import CustomerRecordWidgetItemId
                                             from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItemId";
import CustomerRecordWidgetItems
                                             from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItems";
import RecordTemplate                        from "../../../../domain/record/template/RecordTemplate";
import RecordTemplates                       from "../../../../domain/record/template/RecordTemplates";
import { ResKaState }                        from "../../../../index";
import CustomerRecordDataSource
                                             from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";
import RouterDispatcher                      from "../../../../infrastructure/redux/router/RouterDispatcher";

const CustomerRecordNewButton: FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedTemplate, setTemplate] = useState(new RecordTemplate());
  const getRecordTemplates: GetRecordTemplates = new GetRecordTemplates(useDispatch());
  const templates: RecordTemplates = useSelector((state: ResKaState) => state.templates);
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  useEffect(() => {
    if (open) {
      setTemplate(new RecordTemplate());
      getRecordTemplates.execute();
    }
  }, [open]);

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => setOpen(true) }
      >
        <Icon name="plus"/>
        記録を新しく作成する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>記録テンプレートの選択</Modal.Header>

        <Modal.Content>
          {
            templates.isEmpty() ?
              <>
                <p>記録テンプレートがまだ作成されていません。</p>
              </>
              :
              <>
                <Table
                  striped
                  selectable
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell width={ 1 }>選択</Table.HeaderCell>
                      <Table.HeaderCell>記録テンプレート名</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      templates.toList().map(template => (
                        <>
                          <Table.Row onClick={ () => setTemplate(template) }>
                            <Table.Cell>
                              <Radio
                                name="templateSelect"
                                checked={ selectedTemplate.id.value === template.id.value }
                                onChange={ () => setTemplate(template) }
                              />
                            </Table.Cell>
                            <Table.Cell>{ template.name.value }</Table.Cell>
                          </Table.Row>
                        </>
                      ))
                    }
                  </Table.Body>
                </Table>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ isNaN(selectedTemplate.id.value) }
            positive
            onClick={ () => {
              setOpen(false);
              repository.setCustomerRecord(
                new CustomerRecord
                (new CustomerRecordId(),
                  new Date(),
                  new CustomerRecordTemplate(
                    selectedTemplate.id,
                    selectedTemplate.revision,
                    selectedTemplate.name,
                    new CustomerRecordWidgets(
                      selectedTemplate.widgets.toList().map(widget => (
                        new CustomerRecordWidget(
                          new CustomerRecordWidgetId(),
                          widget.id,
                          widget.type,
                          widget.coordinate,
                          widget.title,
                          widget.value,
                          new CustomerRecordWidgetItems(
                            widget.items.toList().map(item => (
                              new CustomerRecordWidgetItem(
                                new CustomerRecordWidgetItemId(),
                                item.id,
                                item.title,
                                item.value,
                              )
                            ))
                          )
                        )
                      ))
                    )
                  )
                )
              );
              routerDispatcher.customerRecordRegister();
            } }
          >
            <Icon name="check"/>
            記録テンプレートを決定
          </Button>

          <Button onClick={ () => setOpen(false) }>閉じる</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default CustomerRecordNewButton;
